<app-si-dialog modalBodyClasses="flex flex-col h-full w-full" [hideHeader]="true" [isLoading]="contactsService.createContactLoadedFlag | async">
	<ng-template appDialogBody>
		<div class="flex flex-col h-full w-full overflow-hidden" style="min-height: 250px">
			<div>
				<app-modal-header-wizard [pages]="headers" [listType]="'Contacts'"></app-modal-header-wizard>
			</div>
			<div class="flex flex-col h-full w-full pt-6 overflow-auto" [ngClass]="{'disable': contactsService.createContactLoadedFlag | async}">
				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.uploadListPage">
					<div class="flex flex-wrap -mx-2 text-center mb-4">
						<div class="w-full sm:flex-none sm:w-full px-2">
							<h5>Upload Your Contact List</h5>
							Upload a .csv file with your contacts from your computer. Each contact must contain a contact identifier:<br>
							Email address; LinkedIn URL; or First & Last name + one of: company domain, company name, work phone, or mobile phone.<br />
							You can upload a maximum of <strong>10,000 contacts</strong> per list.
						</div>
					</div>
					<div class="flex flex-col gap-7">
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>List Name:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<mat-form-field appearance="outline" class="w-full">
									<mat-label>List Name</mat-label>
									<input matInput type="text" [(ngModel)]="list.name" maxlength="100" placeholder="Enter a name for your list" />
								</mat-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto mb-1 self-center px-2">
								<b>CSV File:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<span [hidden]="list.file" class="py-1">
									<label for="file-upload" class="custom-file-upload">
										Choose File
									</label>
									<input id="file-upload" type="file" name="listFile"
										(change)="onFileSelected($event)" #listFile accept=".csv,.txt" />
									(need an example?
									<a id="btnDownload" download="contacttemplate.csv"
										href="../../../../../assets/csv/contacttemplate.csv" target="_blank">Download the template</a>).
								</span>

								<span [hidden]="list.file === undefined">
									<span>{{list.fileName}}</span>&nbsp;&nbsp;&nbsp;<button matButton="outlined" class="mat-small-button" type="reset"
										(click)="resetFile()">clear</button>
								</span>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Availability:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<mat-form-field appearance="outline" class="w-full">
									<mat-label>Availability</mat-label>
									<mat-select [(ngModel)]="list.isPublic" placeholder="Select availability" #siSelectRef="matSelect">
										<mat-option [value]="false">Private</mat-option>
										<mat-option [value]="true">Team</mat-option>
									</mat-select>
									<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
								</mat-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Tags (Optional):</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<app-multi-selector-form-field
									showChipsList="true"
									[items]="tagList$ | async"
									bindLabel="name"
									bindValue="id"
									label="Tags"
									placeholder="Tags"
									[(ngModel)]="list.tags"
									name="tags"
									[isLoading]="(isCreateTagLoading$ | async) || (isGetTagLoading$| async)"
									ngDefaultControl
									listElementTooltipIfTruncated="true"
								>
									<ng-template #preOption let-value="inputValue">
										<span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
									</ng-template>
								</app-multi-selector-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Skip First Row:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 flex items-center px-2">
								<mat-checkbox  [(ngModel)]="list.skipFirstLine">
									<i class="text-[0.875em]">Check if the first line is a header</i>
								</mat-checkbox>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Match On Job History:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 flex items-center px-2">
								<mat-checkbox  [(ngModel)]="list.matchOnJobHistory"></mat-checkbox>
							</div>
						</div>
					</div>
				</div>

				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.columnMappingPage">
					<div class="text-center pt-0 pb-0">
						<h5 class="text-center">Map Fields</h5>
						<p class="small-text text-center text-[0.875em]">Select the matching column in the CSV for each of the
							fields. If a field does not exist in your CSV file, then select -- skip --.</p>
					</div>
					<div class="text-danger text-center" *ngIf="isError != undefined">
						<p>{{isError}}</p>
					</div>

					<div class="flex flex-wrap -mx-2 gap-y-7">
						<div class="flex-none w-1/2 px-2" *ngFor="let field of columnStepDetails">
							<mat-form-field [ngClass]="{ 'mat-form-field-invalid': field.isError }" appearance="outline" class="w-full">
								<mat-label>{{field.displayName}}</mat-label>
								<mat-select [id]="field.propertyName" [name]="field.propertyName" [(ngModel)]="selectedColumnValues[field.propertyName]" #siSelectRef2="matSelect">
									<mat-option [value]="'0'">-- skip --</mat-option>
									<mat-option *ngFor="let item of fileHeaders; let i = index" [value]="(i+1)">{{item}}</mat-option>
								</mat-select>
								<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
							</mat-form-field>
						</div>
					</div>
				</div>

				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.resultPage">
					<div *ngIf="!(contactsService.createContactLoadedFlag | async)">
						<app-contact-view [listname]="data?.listname" [contactDetail]="contactDetail" [listDetail]="list" (viewContact)="close()"></app-contact-view>
						<div>
							<mat-radio-group [(ngModel)]="selectedView">
								<mat-radio-button class="mr-4" [value]="0" (change)="onChangeType('contactView')">Contact View</mat-radio-button>
								<mat-radio-button [value]="1" (change)="onChangeType('fieldView')">Field View</mat-radio-button>
							</mat-radio-group>
						</div>
						<div class="summary mt-4">
							<nav class="nav-detail nav-equal" *ngIf="selectedView == 0">
								<app-contact-matrix-panel [contactMatrix]="contactDetail" [listDetail]="list" (contactClick)="close()">
								</app-contact-matrix-panel>
							</nav>
						</div>
						<div class="summary mt-4" *ngIf="selectedView == 1">
							<div class="panel panel-default">
								<app-field-view [listDetail]="list" [data]="contactDetail" (contactClick)="close()"></app-field-view>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="(contactsService.createContactLoadedFlag | async)" class="result-loader">
			<mat-spinner></mat-spinner>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div class="flex flex-wrap -mx-2 gap-0 w-full">
			<div class="grow shrink-0 basis-0 px-2">
				<button matButton="outlined" type="button" [disabled]="(contactsService.createContactLoadedFlag | async)"
						class="float-left" (click)="close()" *ngIf="currentPage < 2 ">Cancel</button>
			</div>
			<div class="flex-none w-auto px-2">
				<button matButton="filled" type="button" class="float-right" (click)="onNext()"
						[disabled]="isNextButtonDisabled() || (contactsService.createContactLoadedFlag | async)">
					{{nextButtonCaption}}</button>
				<button matButton="outlined" type="button" class="float-right mr-2" (click)="onPrevious()"
						*ngIf="currentPage === 1" [hidden]="isListProcessing">Previous</button>
			</div>
		</div>
	</ng-template>
</app-si-dialog>
